import { Component } from 'react';
import { Provider } from 'mobx-react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import PropTypes from 'prop-types';
import InformationBoxData from './stores/InformationBoxStore';
import ModalData from './stores/ModalStore';
import ToolTipData from './stores/ToolTipStore';
import MainData from './stores/MainStore';
import RouterData from './stores/RouterStore';
import ProviderLabelData from './stores/ProviderLabelStore';
import NhgRegulationData from './stores/NhgRegulationStore';

class RouterWithProvider extends Component {
  history = createBrowserHistory({ basename: '/' });

  render() {
    const defaultStores = {
      ModalData,
      RouterData,
      MainData,
      ToolTipData,
      ProviderLabelData,
      InformationBoxData,
      NhgRegulationData,
    };

    const stores = { ...defaultStores, ...this.props.stores };

    return (
      <Provider {...stores}>
        <Router history={this.history}>
          {this.props.children}
        </Router>
      </Provider>
    );
  }
}

RouterWithProvider.propTypes = {
  children: PropTypes.node,
  stores: PropTypes.shape({}),
};

RouterWithProvider.defaultProps = {
  children: null,
  stores: {},
};

export default RouterWithProvider;
